export default __webpack_public_path__ + "src/assets/add_bold.8aafed4d202ec5f7b9ad4f765c8bb4e5.svg";